const LOCATIONS_ENDPOINT = process.env.REACT_APP_LOCATIONS_ENDPOINT;
const LOCATIONS_ENDPOINT_DOCKER = process.env.REACT_APP_LOCATIONS_ENDPOINT_DOCKER;
const LOCATIONS_AUTH_USERNAME = process.env.REACT_APP_LOCATIONS_AUTH_USERNAME;
const LOCATIONS_AUTH_PASSWORD = process.env.REACT_APP_LOCATIONS_AUTH_PASSWORD;

const fetchLocations = async (isDocker) => {
    try {
        // console.log(`${LOCATIONS_ENDPOINT}`);

        const url = isDocker
            ? LOCATIONS_ENDPOINT
            : LOCATIONS_ENDPOINT_DOCKER;

        const authHeader = 'Basic ' + btoa(`${LOCATIONS_AUTH_USERNAME}:${LOCATIONS_AUTH_PASSWORD}`);

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': authHeader
            },
            signal: AbortSignal.timeout(120000)
        });

        // console.log('status', response.status);

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`)
        }

        const text = await response.text();
        if (!text) {
            throw new Error('Empty response body.')
        }
        return JSON.parse(text);

    } catch (error) {
        console.error("Fehler beim herunterladen der Fachpartnerdaten:", error);
        throw error;
    }
};

export {
    fetchLocations
};
